// extracted by mini-css-extract-plugin
module.exports = {"imageContainerDotted":"images_imageContainerDotted__1Uel6","imageThumbnail":"images_imageThumbnail__1cnFE","removePhoto":"images_removePhoto__13Mko"};